import axios from "axios";
import config from "../config";

export const getPlayerWallet = (token: string) => axios.get(`${config.API_URL}/wallet/player`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const getTeamWallet = (token: string, teamId: string) => axios.get(`${config.API_URL}/wallet/${teamId}/team`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const playerTransfer = ({
    token,
    alias,
    amount,
    entity,
}: {
    token: string,
    alias: string,
    amount: string,
    entity: string,
}) => axios.post(`${config.API_URL}/wallet/transfer`, {
    alias,
    amount,
    entity,
}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const teamTransfer = ({
    token,
    alias,
    amount,
    entity,
    teamId
}: {
    token: string,
    alias: string,
    amount: string,
    entity: string,
    teamId: string
}) => axios.post(`${config.API_URL}/wallet/team/transfer`, {
    alias,
    amount,
    entity,
    teamId
}, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})